/**
 * Theme toggle clair/sombre pour le microsite Miró.
 *
 * Mode sombre = défaut (immersion expo, demande Clémentine 16/06/2026).
 * Mode clair = alternative (fond crème, esprit "pas de porte", lecture
 * éditoriale prolongée / préférence individuelle accessibilité).
 *
 * - Persistance via localStorage (clé 'miro-theme').
 * - Bouton injecté dynamiquement en bas à gauche, à côté du switcher gtranslate.
 * - Icônes soleil/lune SVG (le soleil s'affiche en mode sombre pour suggérer
 *   "cliquer pour passer au clair", et inversement).
 * - RGAA : aria-label, aria-pressed, focus visible, support clavier.
 *
 * Note FOUC : par défaut le CSS est sombre dans :root, donc même avant le JS
 * la page rend en sombre. Si l'utilisateur a stocké 'light', le JS pose
 * data-theme="light" au plus tôt — un script inline en <head> permettrait
 * d'éliminer le flash résiduel (page.html.twig).
 */
(function () {
  'use strict';

  const STORAGE_KEY = 'miro-theme';
  const root = document.documentElement;

  function applyTheme(theme) {
    if (theme === 'light') {
      root.setAttribute('data-theme', 'light');
    } else {
      root.removeAttribute('data-theme');
    }
    const button = document.querySelector('.theme-toggle');
    if (button) {
      // aria-pressed reflète l'état "mode clair activé" (pressé = clair)
      button.setAttribute('aria-pressed', theme === 'light' ? 'true' : 'false');
      button.setAttribute(
        'aria-label',
        theme === 'light'
          ? "Activer le mode sombre (immersion expo)"
          : "Activer le mode clair (fond crème, esprit pas de porte)"
      );
    }
  }

  function readStoredTheme() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function storeTheme(theme) {
    try {
      localStorage.setItem(STORAGE_KEY, theme);
    } catch (e) {
      /* no-op */
    }
  }

  // Init : applique le thème stocké, sinon sombre par défaut.
  const stored = readStoredTheme();
  applyTheme(stored === 'light' ? 'light' : 'dark');

  // Inject le bouton toggle dans le DOM (en bas à gauche, à côté gtranslate).
  function injectToggle() {
    if (document.querySelector('.theme-toggle')) {
      return;
    }
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'theme-toggle';
    button.innerHTML = `
      <svg class="theme-toggle__icon theme-toggle__icon--sun" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="4.5" fill="currentColor"/>
        <g stroke="currentColor" stroke-width="2" stroke-linecap="round">
          <line x1="12" y1="2" x2="12" y2="5"/>
          <line x1="12" y1="19" x2="12" y2="22"/>
          <line x1="2" y1="12" x2="5" y2="12"/>
          <line x1="19" y1="12" x2="22" y2="12"/>
          <line x1="4.5" y1="4.5" x2="6.7" y2="6.7"/>
          <line x1="17.3" y1="17.3" x2="19.5" y2="19.5"/>
          <line x1="4.5" y1="19.5" x2="6.7" y2="17.3"/>
          <line x1="17.3" y1="6.7" x2="19.5" y2="4.5"/>
        </g>
      </svg>
      <svg class="theme-toggle__icon theme-toggle__icon--moon" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z" fill="currentColor"/>
      </svg>
    `;
    button.addEventListener('click', function () {
      const current = root.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
      const next = current === 'light' ? 'dark' : 'light';
      applyTheme(next);
      storeTheme(next);
    });

    // Injection ciblée : dans la navbar à côté du menu (desktop sticky).
    // Fallback : floating bottom-left si la navbar est absente.
    const navTarget =
      document.querySelector('.navbar .navbar-collapse') ||
      document.querySelector('.navbar > .container') ||
      document.querySelector('.navbar');
    if (navTarget) {
      button.classList.add('theme-toggle--inline');
      navTarget.appendChild(button);
    } else {
      button.classList.add('theme-toggle--floating');
      document.body.appendChild(button);
    }

    // Re-applique le thème pour mettre à jour aria-* sur le bouton fraîchement créé
    applyTheme(root.getAttribute('data-theme') === 'light' ? 'light' : 'dark');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectToggle);
  } else {
    injectToggle();
  }
})();
